const ClientInvoiceStatusConstants = {
    DRAFT: 0,
    UNPAID: 1,
    PAID: 2,
}

export default ClientInvoiceStatusConstants